import api from './api'
export default {
    get: function(parms) {
      return api.get('overview',{
        params: parms
        })
    },
    
  }